// Get the modal
var modalQuaternary = document.querySelector('.modal--quaternary');

// Get the button that opens the modal
var btnQuaternary1 = document.querySelector('.product-gallery__badge .badge--quaternary');
var btnQuaternary2 = document.querySelector('.product-info__badge-list .badge--quaternary');
var btnQuaternary3 = document.querySelector('.product-detail__badge .badge--quaternary');

// Get the <span> element that closes the modal
var closeQuaternaryBtn = document.querySelector(".modal--quaternary__close");

// When the user clicks the button, open the modal 
if (typeof(btnQuaternary1) != 'undefined' && btnQuaternary1 != null) {
  btnQuaternary1.onclick = function() {
    modalQuaternary.style.display = "flex";
  }
}
if (typeof(btnQuaternary2) != 'undefined' && btnQuaternary1 != null) {
  btnQuaternary2.onclick = function() {
    modalQuaternary.style.display = "flex";
  }
}
if (typeof(btnQuaternary3) != 'undefined' && btnQuaternary1 != null) {
  btnQuaternary3.onclick = function() {
    modalQuaternary.style.display = "flex";
  }
}
// When the user clicks on <span> (x), close the modal
closeQuaternaryBtn.onclick = function() {
  modalQuaternary.style.display = "none";
}



// Get the modal
var modalQuinary = document.querySelector('.modal--quinary');

// Get the button that opens the modal
var btnQuinary1 = document.querySelector('.product-gallery__badge .badge--quinary');
var btnQuinary2 = document.querySelector('.product-info__badge-list .badge--quinary');
var btnQuinary3 = document.querySelector('.product-detail__badge .badge--quinary');

// Get the <span> element that closes the modal
var closeQuinaryBtn = document.querySelector(".modal--quinary__close");

// When the user clicks the button, open the modal 
if (typeof(btnQuinary1) != 'undefined' && btnQuinary1 != null) {
  btnQuinary1.onclick = function() {
    modalQuinary.style.display = "flex";
  }
}
if (typeof(btnQuinary2) != 'undefined' && btnQuinary2 != null) {  
  btnQuinary2.onclick = function() {
    modalQuinary.style.display = "flex";
  }
}
if (typeof(btnQuinary3) != 'undefined' && btnQuinary3 != null) {
  btnQuinary3.onclick = function() {
    modalQuinary.style.display = "flex";
  }
}

// When the user clicks on <span> (x), close the modal
closeQuinaryBtn.onclick = function() {
  modalQuinary.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modalQuinary || event.target == modalQuaternary) {
    modalQuinary.style.display = "none";
    modalQuaternary.style.display = "none";
  }
}